import { createApiQueryHook, IApiQueryFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { ICertificationIssuerResource } from "../types";

export type ICertificationIssuerQueryParameters = {
    certificationIssuer?: RelationalValue<ICertificationIssuerResource>;
};
export type ICertificationIssuerQueryResult = ICertificationIssuerResource;

export const certificationIssuerQuery: IApiQueryFunction<ICertificationIssuerQueryParameters> = ({
    certificationIssuer,
}) => {
    if (!certificationIssuer) {
        return;
    }

    return {
        method: "GET",
        url: `/certification_issuers/${mapRelationalValue(certificationIssuer)}`,
    };
};

export const useCertificationIssuerQuery = createApiQueryHook<
    ICertificationIssuerQueryParameters,
    ICertificationIssuerQueryResult
>(certificationIssuerQuery);
